import React, { Component, useContext, useEffect } from 'react';
import Axios from 'axios';
import { useParams } from "react-router-dom";


import { PageHeader, Tabs, Button, Form, Input, Divider, Select, InputNumber, Row, Col, message, Checkbox } from 'antd';
import {
    SaveOutlined
} from "@ant-design/icons";
import { BaseContext } from '../BaseContext';

const CreateGame = () => {
    const { token, setToken, setUser, setEmail } = useContext(BaseContext);

    let { id } = useParams();
    const [form] = Form.useForm();
    const { TabPane } = Tabs;
    const { Option } = Select;
    const genres = ['Action', 'Adventures', 'Animation', 'Battle Royale', 'Fantasy', 'Fighting', 'FPS', 'Horor', 'MOBA', 'Mystery', 'Racing', 'Rhytm', 'RPG', 'Shooter', 'Simulation', 'Sport', 'Strategy', 'War'];
    const platforms = ['Windows', 'Linux', 'Android', 'PC', 'Playstation 4', 'Playstation 3', 'Playstation 5', 'Nintendo Switch', 'Xbox', 'Gameboy', 'Nintendo Wii', 'Ios'].sort()

    useEffect(() => {
        Axios.get("https://backendexample.sanbersy.com/api/data-game/" + id).then(
            (response) => {
                let game = response.data;
                let single = game.singlePlayer ? 'single' : null;
                let multi = game.multiplayer ? 'multi' : null;
                let arr = [];
                if (single) arr.push(single);
                if (multi) arr.push(multi);
                form.setFieldsValue({
                    name: game.name,
                    genre: game.genre.split(','),
                    platform: game.platform.split(','),
                    mode: arr,
                    year: game.release,
                    image_url: game.image_url
                })

            }
        );

    }, []);



    const onFinish = (values) => {
        let single = values.mode.includes('single') ? 1 : 0;
        let multi = values.mode.includes('multi') ? 1 : 0;
        let newGame = {
            name: values.name,
            genre: values.genre.join(', '),
            singlePlayer: single,
            multiplayer: multi,
            platform: values.platform.join(', '),
            release: values.year,
            image_url: values.image_url
        };


        Axios.post('https://backendexample.sanbersy.com/api/data-game',
            newGame,
            { headers: { Authorization: `Bearer ${token}` } }
        ).then(() => {
            window.history.back();
            message.success("Game Successfully Updated");
        }).catch(err => {
            try {
                if (err.response.data.status.includes('Token')) {
                    message.error('Token Expired , Please Log in Again!!');
                    setToken("");
                    setUser("");
                    setEmail("");
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    localStorage.removeItem("email");
                }
            } catch (err) {
                window.history.back();
                message.error('error in creating data API, please try again later!');
            }
        }

        )
    };



    return (
        <div style={{ padding: "0" }}>
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Back"
                style={{ minHeight: "92vh" }}
            >

                <Divider style={{ marginTop: "1vh" }} />
                <h2 style={{ textAlign: "center", marginBottom: "5vh" }}>Create Game</h2>
                <Form
                    form={form}
                    name="basic"
                    initialValues={{
                        ['year']: 2020,

                    }}
                    onFinish={onFinish}

                >
                    <Form.Item
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        label="Game Title"
                        name="name"

                        rules={[{ required: true, message: 'Please input game title' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        name="genre"
                        label="Select Genre"
                        rules={[{ required: true, message: 'Please select game genre!', type: 'array' }]}
                    >
                        <Select mode="multiple" placeholder="Select game genre!">
                            {genres.map(genre => <Option value={genre}>{genre}</Option>)}

                        </Select>
                    </Form.Item>


                    <Form.Item name="mode" label="Selet Game Mode" labelCol={{ span: 3 }}
                        wrapperCol={{ span: 24 }}
                        rules={[{ required: true, message: 'Please select game mode!', type: 'array' }]}
                    >
                        <Checkbox.Group>
                            <Row>
                                <Col >
                                    <Checkbox value="single" style={{ lineHeight: '32px' }}>
                                        Single Player
                                </Checkbox>
                                </Col>

                                <Col >
                                    <Checkbox value="multi" style={{ lineHeight: '32px' }}>
                                        Multi Player
                                    </Checkbox>
                                </Col>

                            </Row>
                        </Checkbox.Group>
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        name="platform"
                        label="Select Platform"
                        rules={[{ required: true, message: 'Please select game platform!', type: 'array' }]}
                    >
                        <Select mode="multiple" placeholder="Select game platform!">
                            {platforms.map(platform => <Option value={platform}>{platform}</Option>)}

                        </Select>
                    </Form.Item>

                    <Form.Item label="Release Year" labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        required={true}
                    >
                        <Form.Item name="year" noStyle rules={[{ required: true, message: 'Please input release year!' }]}>
                            <InputNumber min={1950} />
                        </Form.Item>
                        <span className="ant-form-text"></span>
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 9 }}
                        label="Image Url"
                        name="image_url"
                        placeholder="please input game image url"
                        rules={[{ required: true, message: 'Please input game image url    ' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Row>
                        <Col style={{ marginTop: "4vh" }}>
                            <Button type="primary" htmlType="submit" >
                                <SaveOutlined /> Update Game
                        </Button>
                        </Col>
                    </Row>
                </Form>

            </PageHeader>
        </div>
    )
}

export default CreateGame;